import type { WhatsAppTemplatePresentation } from "@multi-chat/shared";

export function shouldResolveTemplateHeaderImage(
  presentation: WhatsAppTemplatePresentation | undefined,
): boolean {
  return presentation?.header?.type === "IMAGE" && !presentation.header.imageUrl;
}

export function presentationWithHeaderImageUrl(
  presentation: WhatsAppTemplatePresentation,
  imageUrl: string | null,
): WhatsAppTemplatePresentation {
  if (!imageUrl || presentation.header?.type !== "IMAGE") {
    return presentation;
  }
  return {
    ...presentation,
    header: {
      ...presentation.header,
      imageUrl,
      missing: false,
    },
  };
}
